<template>
  <div style="padding: 15px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="160px">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="实际承运人实收现金">
            <el-input v-model="row.deliveryCashFee" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="已打款金额">
            <el-input v-model="row.allotAmount" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="已分配油点">
            <el-input v-model="row.allotOil" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="可分配现金" prop="cash">
            <el-input v-model="row.freight" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="验证码" prop="dto.smsCode">
            <el-input v-model="form.dto.smsCode" maxlength="20" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple-light">
            <el-button
              v-show="show"
              type="primary"
              round
              size="small"
              @click="getCode"
              >获取验证码</el-button
            >
            <span
              v-show="!show"
              style="height: 40px;line-height: 40px;display: block;padding-left: 5px;"
              >{{ count }}</span
            >
          </div>
        </el-col>
      </el-row>
      <el-form-item label="">
        <el-button
          type="primary"
          :disabled="updating"
          @click="funcSubmit('form')"
          >确定</el-button
        >
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24">
        <vxe-table border height="250" :data="tableData" :loading="loading">
          <vxe-table-column
            field="orderDetailNumber"
            title="运单号"
            min-width="150"
          />
          <vxe-table-column field="amount" title="分配现金" min-width="150" />
          <vxe-table-column
            field="gmtCreated"
            title="分配时间"
            min-width="150"
          />
        </vxe-table>
        <vxe-pager
          :loading="loading"
          :current-page.sync="formPage.pageNum"
          :page-size.sync="formPage.pageSize"
          :page-sizes="Pagingconf"
          :total="formPage.total"
          :layouts="[
            'PrevJump',
            'PrevPage',
            'Number',
            'NextPage',
            'NextJump',
            'Sizes',
            'FullJump',
            'Total'
          ]"
          @page-change="handlePageChange"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { obtainPrepayConfirm, obtainPrepayApply } from "@/api/InternetBanking";
import { remitDefinite } from "@/api/transport";
export default {
  name: "AllocateOil",
  props: {
    codes: {
      type: [String, Array],
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      updating: true,
      row: "",
      show: true,
      count: "",
      form: {
        dto: {
          smsCode: ""
        }
      },
      rules: {
        dto: {
          smsCode: [
            { required: true, message: "请输入验证码", trigger: "blur" }
          ]
        }
      },
      tableData: [],
      formPage: {
        payTypes: "3,4,5",
        orderDetailCode: "",
        pageNum: 1,
        pageSize: 20,
        totaltotal: 0
      },
      Pagingconf: [20, 30, 50, 100],
      loading: false
    };
  },
  methods: {
    getInfo(row, form) {
      this.row = row;
      this.count = 0;
      this.show = true;
      this.Allocationrecord();
    },
    //获取验证码
    getCode() {
      const rLoading = this.openLoading();
      obtainPrepayApply({ codes: this.codes }).then(response => {
        rLoading.close();
        this.form.dto = response.data;
        this.$set(this.form.dto, "smsCode", "");
        this.updating = false;
        this.form.mybankBalancePayDTO = response.data;
        if (response.status == 0) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    // 提交
    funcSubmit(form) {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.updating = true;
          const rLoading = this.openLoading();
          obtainPrepayConfirm(this.form.dto).then(
            response => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("hideModel");
              rLoading.close();
              this.updating = false;
              this.count = 0;
            },
            data => {
              rLoading.close();
              this.updating = false;
            }
          );
        } else {
          return false;
        }
      });
    },
    // 记录列表
    Allocationrecord() {
      this.tableData = [];
      this.loading = true;
      this.formPage.orderDetailCode = this.row.orderDetailCodes;
      remitDefinite(this.formPage).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.formPage.total = response.data.total;
        this.loading = false;
      });
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.formPage.pageNum = currentPage;
      this.formPage.pageSize = pageSize;
      this.Allocationrecord();
    }
  }
};
</script>
